import type { RootState } from '@/store';
import type { IUtilsState } from '@/store/types';

export const selectProvincesList = (state: RootState): IUtilsState['provincesList'] => state.utils.provincesList;
export const selectCurrentWeek = (state: RootState): IUtilsState['currentWeek'] => state.utils.currentWeek;
export const selectWeeks = (state: RootState): IUtilsState['weeks'] => state.utils.weeks;
export const selectWeeksByMonth = (state: RootState): IUtilsState['weeksByMonth'] => state.utils.weeksByMonth;
export const selectCalendarDayWidth = (state: RootState): IUtilsState['calendarDayWidth'] =>
  state.utils.calendarDayWidth;
export const selectActiveModalShiftId = (state: RootState): IUtilsState['activeModalShiftId'] =>
  state.utils.activeModalShiftId;
export const selectIsMobileScreenSize = (state: RootState): IUtilsState['isMobileScreenSize'] =>
  state.utils.isMobileScreenSize;
export const selectCountriesList = (state: RootState): IUtilsState['countriesList'] => state.utils.countriesList;
export const selectClassesList = (state: RootState): IUtilsState['classesList'] => state.utils.classesList;
export const selectDeviceType = (state: RootState): IUtilsState['deviceType'] => state.utils.deviceType;
export const selectViewMode = (state: RootState): IUtilsState['viewMode'] => state.utils.viewMode;
